import { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import { css, styled } from '@mui/material/styles';

import ErrorNotificationImg from 'img/notification-error.svg?react';

export const NotificationsLoadError: FC = () => (
  <StyledEmptyNotificationsGrid
    container
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <ErrorNotificationImg />
    <StyledEmptyStateTitle variant="h3">Issue Loading Notifications</StyledEmptyStateTitle>
    <StyledEmptyStateTitle variant="form-text">
      Please refresh / try again in a moment.
    </StyledEmptyStateTitle>
  </StyledEmptyNotificationsGrid>
);

const StyledEmptyNotificationsGrid = styled(Grid)`
  position: relative;
  top: 20%;
`;

const StyledEmptyStateTitle = styled(Typography)(
  ({ theme }) => css`
    color: ${theme.palette.text.disabled};
  `
);
